import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=53f2c5fe&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f2c5fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('53f2c5fe', component.options)
    } else {
      api.reload('53f2c5fe', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=53f2c5fe&scoped=true&", function () {
      api.rerender('53f2c5fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/settings/Index.vue"
export default component.exports